import FileSize from "../../components/commonComponent/FileSize";
import React, { useState } from "react";
import SiteHeader from "../landing/components/Header/SiteHeader";
import Footer from "../landing/components/Footer/Footer";
import useFocusPageStart from "../../hooks/useFocusPageStart";
import Breadcrumb from "../schemes/components/Breadcrumb/Breadcrumb";
import { PdfPreviewModal } from "../rightToInformation/components/RtiContent/PdfDocumentTable";
import faqPdf from "../../assets/career_pdf/FAQ 31.07.2026.pdf";

const FAQ_PAGE_TITLE = "Frequently Asked Questions (FAQs)";
const FAQ_PAGE_HEADING = FAQ_PAGE_TITLE;

const faqDocuments = [
  {
    serial: 1,
    title: FAQ_PAGE_TITLE,
    fileName: "FAQ 31.07.2026.pdf",
    href: faqPdf,
  },
];

const PdfBadge = () => (
  <span className="relative inline-block h-7 w-6 shrink-0 rounded-[3px] bg-[#dfe5ea] shadow-[0_1px_2px_rgba(0,0,0,0.16)]">
    <span className="absolute right-0 top-0 h-0 w-0 border-b-[8px] border-l-[8px] border-b-[#c7d0d8] border-l-transparent" />
    <span className="absolute left-1/2 top-[13px] -translate-x-1/2 rounded-[2px] bg-[#ff5145] px-[3px] py-[1px] text-[8px] font-bold leading-none text-white">
      PDF
    </span>
  </span>
);

const PageTitle = () => (
  <h1 className="m-0 text-[22px] font-bold leading-[1.2] uppercase tracking-[0.5px] text-[#16376c] md:text-[24px] first-letter:text-[#ff9933]">
    {FAQ_PAGE_HEADING}
  </h1>
);

const FaqDocumentTable = () => {
  const [selectedDocument, setSelectedDocument] = useState(null);

  return (
    <>
      <section className="rounded-2xl bg-white p-5 shadow-[0_10px_30px_rgba(0,0,0,0.04)]">
        <div className="overflow-hidden rounded-xl border border-[#d9e4ef]">
          <div className="overflow-x-auto">
            <table
              className="w-full table-fixed border-collapse text-[16px] text-[#001b33]"
              style={{ minWidth: "560px" }}
            >
              <colgroup>
                <col />
                <col className="w-[140px]" />
              </colgroup>
              <thead>
                <tr className="bg-[#dce9fb] text-left text-[18px] font-bold text-[#001b33]">
                  <th className="px-5 py-4">Title</th>
                  <th className="px-5 py-4 text-center">File</th>
                </tr>
              </thead>
              <tbody>
                {faqDocuments.map((document) => (
                  <tr key={document.title} className="bg-white">
                    <td className="px-5 py-4 align-middle font-medium">
                      {document.title}
                    </td>
                    <td className="px-5 py-4 text-center align-middle">
                      <button
                        type="button"
                        onClick={() => setSelectedDocument(document)}
                        title={document.fileName || document.title}
                        aria-label={`Open ${document.title}`}
                        className="mx-auto inline-flex items-center gap-2 rounded-[3px] text-[#16376c] outline-none transition-colors hover:text-[#0f8a7e] focus:outline-none focus-visible:ring-2 focus-visible:ring-[#0f8a7e] focus-visible:ring-offset-2"
                      >
                        <span className="text-[16px] font-medium underline underline-offset-2">
                          Open
                        </span>
                        <PdfBadge /><FileSize href={document.href} fileName={document.fileName} />



                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </section>

      {selectedDocument && (
        <PdfPreviewModal
          pdfDocument={selectedDocument}
          onClose={() => setSelectedDocument(null)}
        />
      )}
    </>
  );
};

const FaqPage = () => {
  useFocusPageStart("/frequently-asked-questions");

  const breadcrumbItems = [
    { label: "Home", path: "/" },
    { label: FAQ_PAGE_TITLE, path: "/frequently-asked-questions" },
  ];

  return (
    <div className="flex min-h-screen flex-col bg-[#f5f5f5]">
      <SiteHeader className="shadow-[0_2px_4px_rgba(0,0,0,0.1)]">
        <div className="z-[1000] px-5 pt-2 pb-3 md:px-10 md:pb-4">
          <Breadcrumb items={breadcrumbItems} />
        </div>
      </SiteHeader>

      <main
        id="main-content"
        data-readable-content
        tabIndex={-1}
        className="flex-1 outline-none"
      >
        <div className="mx-auto w-full max-w-[1400px] px-5 pb-16 pt-5 md:px-10 md:pb-24 md:pt-6">
          <PageTitle />

          <div className="mt-5">
            <FaqDocumentTable />
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
};

export default FaqPage;
